export default {"src":"/_next/static/media/desktop-code.6c66b1a5.svg","height":49,"width":50,"blurWidth":0,"blurHeight":0};